module.exports = __webpack_public_path__ + "static/hero-how-we-work-c6e716a937a147e8f57fa859ef3bb5c1.png";